<template>
	<v-container fluid>
		<Payment :id="paymentModal.id" :invoice="paymentModal.invoice_id" :show="paymentModal.show"
				 @callback="paymentModalCallback"/>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn v-if="markedRecords.length != 0" class="ml-0" color="success" @click="markAsPaidClick">
					<v-icon small>fa-dollar-sign</v-icon>&nbsp;&nbsp;{{ $t('buttons.markAsPaid') }}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:additional-filters="buyersTable.additionalFilters"
						:excel="true"
						:headers="buyersTable.headers"
						:items="buyersTable.items"
						:total="buyersTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr :key="JSON.stringify(props.item)" :class="{'tour-cancelled-row': (props.item.cancelled == 1), 'cursor-pointer': true, 'cancelled-row': (props.item.cancelled_by != null)}"
								@contextmenu.prevent="editClick(props.item.id, true)">
								<td>
									<v-checkbox v-if="props.item.invoice_id != null" v-model="markedRecords"
												:value="props.item.invoice_id"
												hide-details></v-checkbox>
								</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.id }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.tour_category }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.destination }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.start_date_display }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.subject }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">
									{{ props.item.total_amount_display }}
								</td>
								<td :class="{'text-xs-right': true, 'red--text': props.item.cancelled == 1 && props.item.paid_amount > 0}"
									@click="editClick(props.item.id, false)">
									{{ props.item.paid_amount_display }}
								</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">
									{{ props.item.deposit_due_display }}
								</td>
								<td @click="editClick(props.item.id, false)">{{
										props.item.deposit_due_date_display
									}}
								</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">
									{{ props.item.balance_due_display }}
								</td>
								<td @click="editClick(props.item.id, false)">{{
										props.item.balance_due_date_display
									}}
								</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.payment_account }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.invoice_number }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.transaction_id }}</td>
								<td>
									<v-tooltip
										v-if="props.item.invoice_id != null && props.item.balance_due_display != '0,00 EUR'"
										bottom>
										<v-btn slot="activator" icon @click="addPaymentClick(props.item.invoice_id)">
											<v-icon small>fa-money-bill-alt</v-icon>
										</v-btn>
										<span>{{ $t('tooltips.recordPayment') }}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
						<template #footer>
							<tr>
								<td colspan="6"></td>
								<td class="text-xs-right">{{ buyersTable.sumTotal }}</td>
								<td class="text-xs-right">{{ buyersTable.sumPaid }}</td>
								<td class="text-xs-right">{{ buyersTable.sumDepositDue }}</td>
								<td></td>
								<td class="text-xs-right">{{ buyersTable.sumBalanceDue }}</td>
								<td colspan="5"></td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";
import Payment from "./modals/Payment";

export default {
	name: "CashFlowBuyers",
	components: {DataTable, Payment},
	data: function () {
		return {
			buyersTable: {
				headers: [
					{
						text: '',
						value: 'selection',
						type: '',
						sortable: false,
						align: "left",
						width: "50px",
						searchable: false
					},
					{text: this.$t('fields.tourId'), value: 'tour_id', type: 'string', searchable: 'hidden'},
					{
						text: this.$t('fields.tourCategory'),
						value: 'tour_category_id',
						type: 'dropdown|tour-categories',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.destination'),
						value: 'destination_id',
						type: 'dropdown|destinations',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.startDate'),
						value: 'start_date',
						type: 'date_range',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.buyerName'),
						value: 'subject_id',
						type: 'dropdown|subjects-buyers',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.totalAmount'),
						value: 'total_amount',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.paidAmount'),
						value: 'paid_amount',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.depositDue'),
						value: 'deposit_due',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.depositDueDate'),
						value: 'deposit_due_date',
						type: 'date_range',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.balanceDue'),
						value: 'balance_due',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.balanceDueDate'),
						value: 'balance_due_date',
						type: 'date_range',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.account'),
						value: 'payment_account_id',
						type: 'dropdown|payment-accounts',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.invoice'),
						value: 'invoice_number',
						type: 'string',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.transactionId'),
						value: 'transaction_id',
						type: 'string',
						searchable: 'hidden'
					},
					{
						text: '',
						value: 'actions',
						type: '',
						sortable: false,
						align: "right",
						width: "210px",
						searchable: false
					}
				],
				additionalFilters: [
					{text: this.$t('fields.depositPaid'), value: 'deposit_paid', type: 'boolean', searchable: 'hidden'},
					{text: this.$t('fields.balancePaid'), value: 'balance_paid', type: 'boolean', searchable: 'hidden'},
				],
				items: [],
				total: 0,
				lastRequest: null,
				sumTotal: 0,
				sumPaid: 0,
				sumDepositDue: 0,
				sumBalanceDue: 0
			},
			paymentModal: {
				show: false,
				id: null,
				invoice_id: null
			},
			markedRecords: []
		}
	},
	methods: {
		markAsPaidClick() {
			let vm = this;
			this.$verify(this.$t('alerts.markAsPaidQuestionMultiple'), (result) => {
				if (result) {
					vm.$APICall('post', 'invoices/mark-as-paid', {records: this.markedRecords}, (data, success) => {
						if (success) {
							vm.markedRecords = [];
							vm.reloadData(vm.buyersTable.lastRequest);
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
		addPaymentClick(invoiceId) {
			this.paymentModal.invoice_id = invoiceId;
			this.paymentModal.show = true;
		},
		paymentModalCallback() {
			this.paymentModal.show = false;
			this.reloadData(this.buyersTable.lastRequest);
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/tours/' + id)
			} else {
				let routeData = this.$router.resolve('/tours/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		reloadData(request) {
			this.buyersTable.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'cash-flow-buyers', request, (data, success) => {
				if (success) {
					vm.markedRecords = [];
					vm.buyersTable.items = data.items;
					vm.buyersTable.total = data.total;
					vm.buyersTable.sumTotal = data.sum_total_display;
					vm.buyersTable.sumPaid = data.sum_paid_display;
					vm.buyersTable.sumDepositDue = data.sum_deposit_due_display;
					vm.buyersTable.sumBalanceDue = data.sum_balance_due_display;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.buyersTable.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'cash-flow-buyers', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/cash-flow-buyers', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Reporting');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.cashFlowBuyers'), href: '/#/cash-flow-buyers', disabled: true}
		]);
	}
}
</script>

<style scoped>
.cancelled-row {
	color: #ff0000;
}

.tour-cancelled-row td {
	text-decoration: line-through;
}

.tour-cancelled-row td:first-child {
	text-decoration: none;
}

.tour-cancelled-row td:last-child {
	text-decoration: none;
}
</style>
